import { defineComponent } from "vue";

import PatientsRouter from "./PatientsRouter";
import LevelTwo from "../LevelTwo/LevelTwo.vue";

export default defineComponent({
    components: {
        LevelTwo
    },
    data() {
        return {
            router: null
        };
    },
    mounted() {
        this.router = PatientsRouter;
    }
});
